import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface ReturnsRatiosInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.ROE'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.ROIC'?: ResultRow;
}
export class ReturnRatios {
  'RESULTS.DATA.ECONOMIC_METRICS.ROE';
  'RESULTS.DATA.ECONOMIC_METRICS.ROIC';
  /** return on equity */
  get roe() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.ROE'];
  }
  set roe(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.ROE'] = value;
  }
  /** return on invested capital */
  get roic() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.ROIC'];
  }
  set roic(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.ROIC'] = value;
  }

  constructor(param: ReturnsRatiosInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.ROE'] = param['RESULTS.DATA.ECONOMIC_METRICS.ROE']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.ROE'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.ROIC'] = param['RESULTS.DATA.ECONOMIC_METRICS.ROIC']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.ROIC'])
      : new ResultRow();
  }

  deepCopy() {
    return new ReturnRatios(cloneDeep(this));
  }
}